import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { usePedagogyAccess } from '@/hooks/usePedagogyAccess'
import { pedagogyPaths } from '@/lib/pedagogyRoutes'
import { useAuthStore } from '@/store'

/**
 * Вход в общий реестр отсмотров зависит от роли.
 *
 * Руководитель/advanced открывает общий реестр `/reviews`.
 * Рядовой специалист работает со своими отсмотрами внутри собственной
 * операционной карточки — это прежний пользовательский сценарий раздела.
 *
 * Отдельный route-guard нужен не только навигации: он закрывает и прямой ввод
 * `/management/pedagogy/reviews` в адресную строку под specialist-ролью.
 */
export function PedagogyReviewsRoute({ children }: { children: ReactNode }) {
  const location = useLocation()
  const userId = useAuthStore(state => state.user?.id)
  const { isPedagogySpecialist } = usePedagogyAccess()

  if (isPedagogySpecialist && userId) {
    const params = new URLSearchParams(location.search)
    params.set('tab', 'reviews')
    const query = params.toString()
    const target = `${pedagogyPaths.specialist(userId)}${query ? `?${query}` : ''}${location.hash}`

    return <Navigate to={target} replace />
  }

  return <>{children}</>
}
